



































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class HotkeyLegend extends Vue {

  @Prop(String) public selectDef!: string;
  @Prop(String) public navigateDef!: string;

}
